import React from "react";
import { ReactComponent as Info } from "../../../assets/icons/info.svg";
import {
  IconButton,
  Tooltip,
  Box,
  Typography,
  List,
  ListItem,
} from "@mui/material";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";

const DncPopover = ({ dncData }) => {
  const displayParams = dncData?.customFields?.map((field) => ({
    label: field?.key
      ? field?.key?.charAt(0)?.toUpperCase() + field?.key.slice(1)
      : "",
    value: field?.value || "-",
  }));

  return (
    <Tooltip
      slotProps={{
        tooltip: {
          sx: commonStyles.popoverCard.mainContainer,
        },
      }}
      title={
        <Box sx={{ width: 270 }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{
              p: 1.5,
              borderBottom: "1px solid #e0e0e0",
              bgcolor: "#f5f5f5",
            }}
          >
            DNC Details
          </Typography>

          <Box sx={{ p: 1.5 }}>
            <List dense disablePadding sx={{ m: 0 }}>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <Typography variant="body2">
                  <strong>Phone: </strong>
                  {dncData?.phone}
                </Typography>
              </ListItem>
              {displayParams?.map((item) => (
                <ListItem key={item.label} disablePadding sx={{ mb: 1 }}>
                  <Typography variant="body2">
                    <strong>{item?.label}: </strong>
                    {item?.value}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Box>
        </Box>
      }
      placement="left"
      arrow
      enterDelay={300}
      leaveDelay={200}
    >
      <IconButton>
        <Info title="Info" />
      </IconButton>
    </Tooltip>
  );
};

export default DncPopover;
